"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const iconoir_react_1 = require("iconoir-react");
// import app components
const colors_1 = __importDefault(require("../../../theme/colors"));
const input_1 = __importDefault(require("../../elements/input"));
const paper_1 = __importDefault(require("../../elements/paper"));
const AutoComplete = (props) => {
    const { label, placeholder = "Search...", showStartIcon = true, options, ...rest } = props;
    return (react_1.default.createElement(material_1.Autocomplete, { PaperComponent: (props) => {
            return (react_1.default.createElement(paper_1.default, { ...props, sx: {
                    background: colors_1.default.secondary[600],
                    p: 0,
                    width: "auto",
                    borderRadius: "1rem",
                    mt: 1,
                    // Only show border if children are present
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    ...(props?.children?.[2]?.props?.children.length > 0 && {
                        border: `solid thin ${colors_1.default.border[700]}`,
                        "&:hover": {
                            border: `solid thin ${colors_1.default.border[100]}`,
                        },
                    }),
                    ul: {
                        m: 0,
                    },
                } }));
        }, popupIcon: react_1.default.createElement(iconoir_react_1.NavArrowDown, { style: { color: colors_1.default.icons[700], fontSize: "0.9rem", background: "transparent" } }), noOptionsText: "No options", options: options, renderInput: (params) => (react_1.default.createElement(input_1.default, { ...params, placeholder: placeholder, InputLabelProps: { shrink: true }, InputProps: {
                ...params.InputProps,
                disableUnderline: true,
                startAdornment: showStartIcon ? (react_1.default.createElement(material_1.InputAdornment, { position: "start" },
                    react_1.default.createElement(iconoir_react_1.Search, { style: { color: colors_1.default.icons[700] } }))) : null,
            }, label: label })), ...rest }));
};
exports.default = AutoComplete;
